/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';
import { parse, stringify } from 'zipson';
import { Names } from './storeName';

// ppt与大纲交互状态管理
export const useStore = defineStore(Names.SECRET, {
  state: () => ({
    yduuid: '',
    token: '',
  }),

  persist: {
    key: 'yd_ai_ppt_store_secret',
    storage: localStorage,
    paths: [
      'yduuid',
      'token',
    ],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },

  getters: {
    getYdId: (state) => state.yduuid,
    getToken: (state) => state.token,
  },

  actions: {
    changeYdId(value) {
      this.yduuid = value;
    },
    changeToken(value) {
      this.token = value;
    },
  },
})
